import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/login.css"; // ✅ import the CSS file
import JoozyLogo from "../../assets/images/joozylogo.png";
import { usePortalScope } from "../../context/PortalScopeContext";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { refreshScope } = usePortalScope();
  const api_url = process.env.REACT_APP_API_URL;

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${api_url}/api/auth/login`, {
        username,
        password,
      });
      localStorage.setItem("token", response.data.token);
      if (response.data.scope) {
        localStorage.setItem("scope", response.data.scope);
      }
      refreshScope();

      navigate("/form");
    } catch (error) {
      Swal.fire({
        title: "Login Failed!",
        text:
          error.response?.data?.error ||
          "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  return (
    <div className="login-page d-flex justify-content-center align-items-center">
      <div className="login-card shadow-sm p-5">
        <div className="text-center mb-4">
          <img src={JoozyLogo} alt="Joozy Logo" className="login-logo" />
          <h2 className="login-title">Sign In</h2>
          <p className="login-subtitle">
            Enter your credentials to access your account
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="form-floating mb-3">
            <input
              type="text"
              id="username"
              className="form-control rounded-3 login-input"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            <label htmlFor="username">Username</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="password"
              id="password"
              className="form-control rounded-3 login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="password">Password</label>
          </div>

          <button type="submit" className="btn login-btn w-100 fw-bold">
            Login
          </button>
        </form>

        <div className="text-center mt-3">
          <a href="/forgot-password" className="forgot-link">
            Forgot Password?
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
